import { render, staticRenderFns } from "./productAlerts.vue?vue&type=template&id=c788e32c"
import script from "./productAlerts.vue?vue&type=script&lang=js"
export * from "./productAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports